import { CSSProperties, FC, memo } from 'react';
import { Capacitor } from '@capacitor/core';
import { Box, Portal } from '@mui/material';

import { TMoplaColors } from '@mopla/mui';

export interface IBackgroundProps {
	className?: string;
	bgColor?: TMoplaColors | CSSProperties['backgroundColor'];
}

const isNativePlatform = Capacitor.isNativePlatform();

export const NativePageBackground: FC<IBackgroundProps> = memo(
	({ className, bgColor }) => {
		if (!isNativePlatform) {
			return null;
		}

		return (
			<Portal>
				<Box
					className={className}
					sx={{
						position: 'fixed',
						zIndex: -1,
						top: 0,
						left: 0,
						right: 0,
						bottom: 'calc(0px + var(--keyboard-height, 0px))',
						backgroundColor: bgColor,
					}}
				/>
			</Portal>
		);
	}
);
